import React, { useEffect, useState } from "react";
import { Form, Col, Row } from "react-bootstrap";
import Select from "react-select";
import axiosClient from "../../../../config/axios.js";

const CraneData = ({
  values,
  errors,
  setFieldValue,
  setFieldTouched,
  isAdmin,
  disabled,
}) => {
  const [gruas, setGruas] = useState([]);
  const [operadores, setOperadores] = useState([]);
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    // Obtener grúas
    axiosClient
      .get("/cranes/all")
      .then((response) => {
        const formattedOptions = response.data.data.map((item) => {
          const etiqueta =
            "#" +
            item.crane_number +
            ", " +
            item.description +
            " (" +
            item.CraneTypes.map((craneType) => craneType.crane_type_name).join(
              ", "
            ) +
            ")";
          return {
            value: item.id,
            label: etiqueta,
            crane_type: item.CraneTypes.map(
              (craneType) => craneType.crane_type_name
            ),
          };
        });
        setGruas(formattedOptions);
      })
      .catch((error) => {
        console.error("Error fetching cranes:", error);
      });

    // Obtener operadores
    axiosClient
      .get("/users/allOperators")
      .then((response) => {
        const formattedOptions = response.data.data
          .filter((operator) => operator.desactivation_date === null)
          .map((operator) => ({
            value: operator.id,
            label:
              operator.name +
              " " +
              operator.first_surname +
              " " +
              operator.second_surname,
            actividad: "",
            encargado: "",
          }));
        setOperadores(formattedOptions);
      })
      .catch((error) => {
        console.error("Error fetching allOperators:", error);
      });
  }, []);

  // Escuchar cambios en chofer_auxiliar_id
  useEffect(() => {
    // Ignorar la primera ejecución
    if (!hasMounted) {
      setHasMounted(true);
      return;
    }

    const choferAux = values.chofer_auxiliar_id;
    let newMontos = [...values.montosExtras];
    const index = newMontos.findIndex(
      (item) => item.id_value === "chofer_auxiliar"
    );

    if (choferAux) {
      // Si hay chofer auxiliar, borrar grúa y operador
      if (values.crane_id || values.operator_id) {
        setFieldValue("crane_id", null);
        setFieldValue("operator_id", null);
      }

      const descripcion = `Chofer auxiliar: ${choferAux.label}`;

      // Si ya existe, solo actualiza la descripción, pero conserva el monto
      if (index !== -1) {
        newMontos[index] = {
          ...newMontos[index],
          monto_extra_descripcion: descripcion,
        };
      } else {
        // Si no existía, agrega una nueva entrada
        newMontos.push({
          id_value: "chofer_auxiliar",
          monto_extra_descripcion: descripcion,
          monto_extra_monto: "",
        });
      }
    } else if (index !== -1) {
      // Si se quitó el chofer auxiliar, eliminar el montoExtra
      newMontos.splice(index, 1);
    }

    setFieldValue("montosExtras", newMontos);
  }, [values.chofer_auxiliar_id]);

  const isDisabled = !!values.chofer_auxiliar_id;

  return (
    <Row>
      <Form.Group as={Col} md="4" className="mb-3">
        <Form.Label>Grúa No.</Form.Label>
        <Select
          name="crane_id"
          options={gruas}
          className={errors.crane_id ? "is-invalid" : ""}
          placeholder="Selecciona una grúa"
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
          isClearable={true}
          isSearchable={true}
          value={values.crane_id}
          isDisabled={isDisabled || disabled}
          onChange={(e) => {
            setFieldTouched("crane_id", true);
            setFieldValue("crane_id", e);
          }}
        />
        <Form.Control.Feedback type="invalid">
          {errors.crane_id}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group as={Col} md="4" className="mb-3">
        <Form.Label>Operador</Form.Label>
        <Select
          name="operator_id"
          options={operadores}
          className={errors.operator_id ? "is-invalid" : ""}
          placeholder="Selecciona un operador"
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
          isClearable={true}
          isSearchable={true}
          value={values.operator_id}
          isDisabled={isDisabled || disabled}
          onChange={(e) => {
            setFieldTouched("operator_id", true);
            setFieldValue("operator_id", e);
          }}
        />
        <Form.Control.Feedback type="invalid">
          {errors.operator_id}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group as={Col} md="4" className="mb-3">
        <Form.Label>Chofer auxiliar</Form.Label>
        <Select
          name="chofer_auxiliar_id"
          options={operadores}
          className={errors.chofer_auxiliar_id ? "is-invalid" : ""}
          placeholder="Selecciona un chofer auxiliar"
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
          isClearable={true}
          isSearchable={true}
          value={values.chofer_auxiliar_id}
          onChange={(e) => {
            setFieldTouched("chofer_auxiliar_id", true);
            setFieldValue("chofer_auxiliar_id", e);
          }}
          isDisabled={disabled}
        />
        <Form.Control.Feedback type="invalid">
          {errors.chofer_auxiliar_id}
        </Form.Control.Feedback>
      </Form.Group>
    </Row>
  );
};

export default CraneData;
